<template>
	<b-form
		ref="form"
		@submit.prevent="setContactPost"
	>

		<b-form-group
			label="Contact"
			for="contact"
		>
			<b-form-select
				v-model="contactId"
				value-field="Id"
				text-field="Name"
				:options="contacts"
			></b-form-select>

		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Set Contact</b-button>

	</b-form>
</template>

<script>
export default {
	name: "AddLimtedContactToParent",

	// things we want to use
	components: {},

	// things we have inherited from our parent
	props: ["contacts"],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			contactId : null,		
		};
	},
	// things we do to data
	methods: {
		setContactPost() {
			let foundContact = this.contacts.filter((contact) => {
				return contact.Id == this.contactId;
			});
			this.$emit("changeContact", foundContact[0]);
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/change-contact.vue